import { Link } from 'react-router-dom';
import { useCompare } from '@/lib/compare';
import { Scale, X } from 'lucide-react';

export const CompareBar = () => {
  const c = useCompare();
  if (!c || c.count === 0) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-slate-900 text-white shadow-2xl border-2 border-orange-500 flex items-center gap-3 px-4 py-2.5">
      <Scale className="h-4 w-4 text-orange-400" />
      <span className="text-sm font-semibold">{c.count}/{c.max} productos para comparar</span>
      <Link
        to="/comparar"
        data-testid="compare-bar-cta"
        className="bg-orange-500 hover:bg-orange-400 text-slate-900 text-xs font-bold px-3 py-1.5"
      >
        Ver comparación
      </Link>
      <button
        onClick={c.clear}
        className="text-slate-300 hover:text-white"
        aria-label="Limpiar"
      ><X className="h-4 w-4" /></button>
    </div>
  );
};
